export default "__VITE_ASSET__4a98e777__"